(function () {
  const root = document.querySelector('[data-product-main]');
  if (!root) return;

  const select = root.querySelector('[data-variant-select]');
  const optionsRoot = root.querySelector('[data-options]');
  const chips = optionsRoot ? Array.from(optionsRoot.querySelectorAll('[data-option-value]')) : [];
  const valueDisplays = optionsRoot ? Array.from(optionsRoot.querySelectorAll('[data-option-value-display]')) : [];
  const priceCurrent = root.querySelector('[data-price-current]');
  const priceCompare = root.querySelector('[data-price-compare]');
  const priceSave    = root.querySelector('[data-price-save]');
  const atc          = root.querySelector('[data-atc]');
  const atcLabel     = root.querySelector('[data-atc-label]');
  const skuEl        = root.querySelector('[data-sku]');
  const stockEl      = root.querySelector('[data-stock]');
  const mainImage    = root.querySelector('[data-main-image] img');
  const thumbs       = Array.from(root.querySelectorAll('[data-thumb]'));

  // Track current option values per option index
  const currentValues = [];
  if (optionsRoot) {
    optionsRoot.querySelectorAll('.ls-pm__option').forEach((opt, idx) => {
      const active = opt.querySelector('.ls-pm__chip.is-active');
      currentValues[idx] = active ? active.textContent.trim() : '';
    });
  }

  const moneyFormat = (window.Shopify && window.Shopify.money_format) || '{{amount}} lei';
  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  };

  const findVariantOption = () => {
    const joined = currentValues.filter(Boolean).join(' / ');
    const option = Array.from(select.options).find((o) => o.dataset.options === joined);
    return option;
  };

  const updateUI = () => {
    const option = findVariantOption();
    if (!option) return;

    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    const price = parseInt(option.dataset.price, 10);
    const compare = parseInt(option.dataset.compare, 10);
    const available = option.dataset.available === 'true';
    const sku = option.dataset.sku;

    if (priceCurrent) priceCurrent.textContent = formatMoney(price);
    if (compare && compare > price) {
      const pct = Math.round(((compare - price) / compare) * 100);
      if (priceCompare) { priceCompare.textContent = formatMoney(compare); priceCompare.hidden = false; }
      if (priceSave) { priceSave.textContent = `economisești ${pct}%`; priceSave.hidden = false; }
      if (priceCurrent) priceCurrent.classList.add('is-red');
    } else {
      if (priceCompare) priceCompare.hidden = true;
      if (priceSave) priceSave.hidden = true;
      if (priceCurrent) priceCurrent.classList.remove('is-red');
    }

    if (atc) atc.disabled = !available;
    if (atcLabel) atcLabel.textContent = available ? 'Adaugă în coș' : 'Stoc epuizat';

    if (skuEl && sku) skuEl.textContent = sku;
    if (stockEl) {
      const dot = stockEl.querySelector('.ls-pm__dot');
      if (dot) dot.classList.toggle('is-on', available);
      stockEl.childNodes.forEach((n) => {
        if (n.nodeType === 3) n.textContent = available ? ' În stoc ' : ' Stoc epuizat ';
      });
    }

    // Update URL with selected variant
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  };

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const [idx, value] = chip.dataset.optionValue.split('|');
      const i = parseInt(idx, 10);
      currentValues[i] = value;

      // Toggle is-active on chips in the same option group
      const groupRoot = chip.closest('.ls-pm__option');
      groupRoot.querySelectorAll('.ls-pm__chip').forEach((c) => c.classList.toggle('is-active', c === chip));

      // Update display value
      const disp = valueDisplays.find((d) => parseInt(d.dataset.optionValueDisplay, 10) === i);
      if (disp) disp.textContent = value;

      updateUI();
    });
  });

  // Quantity stepper
  const qtyInput = root.querySelector('[data-qty-input]');
  const qtyDec = root.querySelector('[data-qty-dec]');
  const qtyInc = root.querySelector('[data-qty-inc]');
  if (qtyInput && qtyDec && qtyInc) {
    qtyDec.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    qtyInc.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
  }

  // Thumbnail click → swap main image
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      if (mainImage && thumb.dataset.src) {
        mainImage.src = thumb.dataset.src;
        mainImage.srcset = '';
      }
    });
  });
})();
